import React, { useEffect, useState } from "react";
import { StyledTableCell } from "../../../components/filesListTable/styles";
import ConciseTable from "../../../components/filesListTable/conciseTable";
import { ThreeDotsPopupMenu } from "../../../components/threeDotsPopupMenu";
import { useHistory } from "react-router-dom";
import { StyledExpiredContainer, StyledLiveContainer} from '../styles'

import {
  StyledProjectSelectionContainer,
  MobileColumnContent,
  MobileColumnText
} from "../styles";

import { truncateString } from "../../../common/truncateString";

export const ActiveAgentList = ({ filteredData, deActiveIdpEsub, activeIdpEsub, isMobile }) => {
  const headers = [
    { title: "ID" },
    { title: "Email" },
    { title: "Institution Name" },
    { title: "User Type" },
    { title: "Status", align: "center" },
    { title: "" },
  ];

  const [data, setData] = useState("");
  let history = useHistory();




  const body = (bodyData) => {
    return (
      <>
        {isMobile && (
          <StyledTableCell component={"tr"} width="90%">
            <MobileColumnContent direction="column">
              <MobileColumnText>
                {truncateString(bodyData?.email, 28)}
              </MobileColumnText>
              <MobileColumnText fontSize="12px" fontWeight="400">
                {truncateString(bodyData?.institution, 30)}
              </MobileColumnText>
            </MobileColumnContent>
          </StyledTableCell>
        )}
        {!isMobile && (
          <>
            <StyledTableCell component={"tr"} width="5%">
              {bodyData?.id}
            </StyledTableCell>
            <StyledTableCell component={"tr"} width="35%">
              {bodyData?.email}
            </StyledTableCell>
            <StyledTableCell component={"tr"} width="30%">
              {bodyData?.institution}
            </StyledTableCell>
            <StyledTableCell component={"tr"} width="20%">
              {bodyData?.user_type}
            </StyledTableCell>
            <StyledTableCell component={"tr"} width="10%">
             {bodyData?.is_agent_to_access_esub_and_idp === null || bodyData?.is_agent_to_access_esub_and_idp === false ? (
                <StyledExpiredContainer>Inactive</StyledExpiredContainer>
              ) : bodyData?.is_agent_to_access_esub_and_idp === true ? (
                <StyledLiveContainer>Active</StyledLiveContainer>
              ) : (
                ""
              )}
            </StyledTableCell>
          </>
        )}
        <StyledTableCell component={"tr"} align="right">
          <ThreeDotsPopupMenu
            item={{ ...bodyData, id: bodyData?.id }}
            removeEdit={"disableEnableIDPeSUBClient"}
            data={filteredData}
            handleDeActiveIdpEsub={deActiveIdpEsub}
            handleActiveIdpEsub={activeIdpEsub}
          />
        </StyledTableCell>
      </>
    );
  };

  return (
    <StyledProjectSelectionContainer isMobile={isMobile}>
      <ConciseTable
        headers={isMobile ? "" : headers}
        length={isMobile ? 6 : 6.5}
        body={body}
        data={filteredData}
      />
    </StyledProjectSelectionContainer>
  );
};
